import { CURRENT_SEASON } from 'common/src/utils/definitions';
import useFilterStore from '../../../common/src/stores/useFiltersStore';
import { Alert } from './ui';
import { Icon } from '@iconify/react';
import { ReactNode } from 'react';
import { useTranslation } from '../../../common/src/hooks/useTranslation';

/**
 * Banner component that displays a warning when the user is not working
 * with the latest/current season
 *
 * Shows: "Estás trabajando en una temporada anterior.
 *         Para cambiarla, ve al navegador izquierdo y selecciona la última temporada disponible."
 */

interface SeasonWarningBannerProps {
  burgerButton?: ReactNode;
}

const SeasonWarningBanner = ({ burgerButton }: SeasonWarningBannerProps) => {
  const { t } = useTranslation('common');
  const { selectedSeason } = useFilterStore();

  // Se compara contra CURRENT_SEASON y no contra la última de SEASONS: la
  // temporada nueva aparece en los selectores apenas empieza el calendario,
  // pero mientras no tenga datos el aviso no corresponde.
  const showBanner = selectedSeason && selectedSeason !== CURRENT_SEASON;

  if (!showBanner) return null;

  return (
    <div className='w-full sticky top-0 z-50'>
      <Alert variant='warning' className='rounded-none border-x-0 border-t-0'>
        <div className='flex items-center gap-2 justify-between'>
          <div className='flex items-center gap-2'>
            <Icon icon='tabler:info-circle' className='flex-shrink-0' width={18} />
            <span>
              {t('Estás trabajando en la temporada')} {selectedSeason}
            </span>
          </div>
          {burgerButton && <div className='md:hidden flex-shrink-0'>{burgerButton}</div>}
        </div>
      </Alert>
    </div>
  );
};

export default SeasonWarningBanner;
